// Slice Tool — creates rectangular slices for web design export.
// Slices define regions of the document that can be exported individually.

import { screenToDoc } from "../render/Viewport";
import type { PointerSample, Tool, ToolContext } from "./Tool";

export interface Slice {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
  name: string;
}

export class SliceTool implements Tool {
  readonly id = "slice";
  readonly shortcut = "C";

  private start: { x: number; y: number } | null = null;
  slices: Slice[] = [];

  onPointerDown(ctx: ToolContext, s: PointerSample): void {
    if (!ctx.doc) return;
    const p = screenToDoc(ctx.viewport, s.x, s.y);
    this.start = { x: p.x, y: p.y };
  }

  onPointerMove(ctx: ToolContext, s: PointerSample): void {
    if (!this.start || !ctx.doc) return;
    ctx.requestRender();
  }

  onPointerUp(ctx: ToolContext, s: PointerSample): void {
    if (!this.start || !ctx.doc) return;
    const p = screenToDoc(ctx.viewport, s.x, s.y);

    let x = Math.min(this.start.x, p.x);
    let y = Math.min(this.start.y, p.y);
    let w = Math.abs(p.x - this.start.x);
    let h = Math.abs(p.y - this.start.y);

    // Clamp to document bounds
    x = Math.max(0, x);
    y = Math.max(0, y);
    w = Math.min(w, ctx.doc.width - x);
    h = Math.min(h, ctx.doc.height - y);

    if (w > 2 && h > 2) {
      this.slices.push({
        id: crypto.randomUUID(),
        x: Math.round(x),
        y: Math.round(y),
        width: Math.round(w),
        height: Math.round(h),
        name: `Slice ${this.slices.length + 1}`,
      });
    }

    this.start = null;
    ctx.requestRender();
  }

  getCurrentRect(): { x: number; y: number; w: number; h: number } | null {
    return null;
  }
}
